import { type ReactElement } from 'react';
import FeaturePageLayout from '../../components/features/FeaturePageLayout';

export default function BWA(): ReactElement {
  return (
    <FeaturePageLayout
      badge="Auswertungen"
      title="BWA: Ihren Unternehmenserfolg bewerten"
      subtitle="Die Betriebswirtschaftliche Auswertung (BWA) zeigt Ihnen auf einen Blick, wie Ihr Unternehmen wirtschaftlich dasteht. Erstellen Sie Ihre BWA mit einem Klick."
      heroImage="/screenshots/app-kennzahlen.webp"
      heroImageAlt="Betriebswirtschaftliche Auswertung in Saldify: Umsatz, Gewinn und Kostenquote im Jahresverlauf"
      features={[
        {
          title: 'Automatische Erstellung',
          description: 'Die BWA wird automatisch aus Ihren Buchungen generiert – immer aktuell.',
        },
        {
          title: 'DATEV-konform',
          description: 'Standard BWA-Struktur, die Ihr Steuerberater kennt und erwartet.',
        },
        {
          title: 'Vergleichsanalysen',
          description: 'Vergleichen Sie Zeiträume und erkennen Sie Trends in Ihrem Geschäft.',
        },
        {
          title: 'PDF-Export',
          description: 'Exportieren Sie Ihre BWA als professionelles PDF für Bank oder Investoren.',
        },
        {
          title: 'Monatlich oder kumuliert',
          description: 'Wählen Sie zwischen Monats-BWA und kumulierter Jahresansicht.',
        },
        {
          title: 'Kennzahlen-Analyse',
          description: 'Wichtige KPIs wie Rohertrag und Personalaufwandsquote auf einen Blick.',
        },
      ]}
      sections={[
        {
          title: 'Ihre Zahlen auf einen Blick',
          description: 'Die BWA-Übersicht zeigt alle wichtigen Kennzahlen grafisch aufbereitet. Umsatz, Materialaufwand, Personalkosten und Gewinn – verstehen Sie Ihr Geschäft besser.',
          bullets: [
            'Umsatzentwicklung im Zeitverlauf',
            'Kostenstruktur nach Kategorien',
            'Rohertrag und Marge',
            'Vorjahresvergleich',
          ],
          imageSide: 'right',
        },
        {
          title: 'Detaillierte Kostenanalyse',
          description: 'Analysieren Sie Ihre Kosten im Detail. Sehen Sie, wo Ihr Geld hinfließt und identifizieren Sie Einsparpotenziale.',
          bullets: [
            'Aufschlüsselung nach Kostenarten',
            'Vergleich mit Vorperioden',
            'Anteil am Gesamtumsatz',
            'Drill-Down bis zur Einzelbuchung',
          ],
          imageSide: 'left',
        },
        {
          title: 'Export für Steuerberater & Bank',
          description: 'Erstellen Sie professionelle BWA-Berichte für Ihren Steuerberater, Ihre Bank oder potenzielle Investoren. Im DATEV-Format oder als übersichtliches PDF.',
          bullets: [
            'DATEV-konformes Format',
            'Professionelles PDF-Layout',
            'Eigenes Logo einfügen',
            'Automatischer Versand',
          ],
          imageSide: 'right',
        },
      ]}
      ctaTitle="Erstellen Sie Ihre erste BWA"
      ctaDescription="Verstehen Sie Ihre Geschäftszahlen besser mit der automatischen BWA von Saldify."
    />
  );
}
